import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

function NotFound() {
  return (
    <div className="min-h-screen bg-dgal-ink text-dgal-mist flex items-center justify-center">
      <div style={{ textAlign: 'center' }}>
        <h1 style={{ color: '#D02736', fontSize: 28, margin: 0 }}>404</h1>
        <p style={{ color: '#9CA3AF', marginTop: 8 }}>Page not found</p>
      </div>
    </div>
  );
}

function Trigger() {
  useEffect(() => {
    throw new Error('Sentry verification ping from dal-web');
  }, []);
  return null;
}

export default function SentryTest() {
  const [params] = useSearchParams();
  const isProd = import.meta.env.MODE === 'production';
  const expectedKey = import.meta.env.VITE_SENTRY_TEST_KEY;
  const providedKey = params.get('key');

  const allowed = !isProd || (Boolean(expectedKey) && providedKey === expectedKey);
  if (!allowed) return <NotFound />;
  return <Trigger />;
}
